import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { servicesData } from './Services';
import { ChevronLeft } from 'lucide-react';

const ServiceDetail = () => {
    const { id } = useParams();
    const service = servicesData.find(s => s.id === id);

    if (!service) {
        return <Navigate to="/services" replace />;
    }

    return (
        <div className="section container">
            <Link to="/services" style={{ display: 'inline-flex', alignItems: 'center', marginBottom: '2rem', color: 'var(--text-light)' }}>
                <ChevronLeft size={20} /> Retour aux services
            </Link>

            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                <div style={{ position: 'relative', height: '400px', marginBottom: '3rem' }}>
                    <img
                        src={service.image}
                        alt={service.title}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '12px'
                        }}
                    />
                    <div style={{
                        position: 'absolute',
                        bottom: '-30px',
                        left: '30px',
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        <div style={{ color: 'var(--primary-color)' }}>{service.icon}</div>
                        <h1 style={{ fontSize: '2rem', margin: 0 }}>{service.title}</h1>
                    </div>
                </div>

                <div style={{ marginTop: '4rem', fontSize: '1.1rem', lineHeight: '1.8' }}>
                    <p>{service.fullDescription}</p>
                    <p style={{ marginTop: '1.5rem' }}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>

                    <div style={{ marginTop: '3rem', padding: '2rem', backgroundColor: 'var(--background-color)', borderRadius: '8px' }}>
                        <h3>Pourquoi nous choisir ?</h3>
                        <ul style={{ listStyle: 'none', marginTop: '1rem', display: 'grid', gap: '1rem' }}>
                            <li style={{ display: 'flex', alignItems: 'center' }}>✓ Chauffeurs expérimentés et formés</li>
                            <li style={{ display: 'flex', alignItems: 'center' }}>✓ Véhicules récents et confortables</li>
                            <li style={{ display: 'flex', alignItems: 'center' }}>✓ Ponctualité garantie</li>
                            <li style={{ display: 'flex', alignItems: 'center' }}>✓ Aide administrative pour vos remboursements</li>
                        </ul>
                    </div>

                    <div style={{ marginTop: '3rem', textAlign: 'center' }}>
                        <Link to="/contact" className="btn btn-primary" style={{ padding: '1rem 2.5rem', fontSize: '1.2rem' }}>
                            Réserver ce service
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceDetail;
